module.exports = __webpack_public_path__ + "static/img/img5.4369e9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img5.jpg
// module id = sKWi
// module chunks = 0